import axios from "axios";
export const getToken = () => {
  return localStorage.getItem("access_token");
};

const axiosInstance = axios.create({
  baseURL: "https://go.7cut.video",
  headers: {
    // Remove default Content-Type to allow FormData to set its own
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Don't set Content-Type for FormData
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {
    console.log("Error:", error);
    if (
      error.response.status === 404 &&
      !error.request.responseURL.includes("/project/role") &&
      error.request.responseURL.includes("/project")
    ) {
      window.location.href = `${window.location.origin}/error/access`;
      return;
    }
    if (
      error.response.status === 404 &&
      !error.request.responseURL.includes("/project/role") &&
      !error.request.responseURL.includes("/legal-document")
    ) {
      window.location.href = `${window.location.origin}/error/404`;
    }

    if (error.response.status === 500) {
      window.location.href = `${window.location.origin}/error/500`;
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
